import React from 'react';

const StandingsTable = ({ standings, loading }) => {
  if (loading) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
        <div className="animate-pulse">
          <div className="h-12 bg-gray-200 dark:bg-gray-700"></div>
          {[...Array(10)].map((_, i) => (
            <div key={i} className="h-14 border-t border-gray-100 dark:border-gray-700 flex items-center px-4">
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full"></div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (!standings || standings.length === 0) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg p-8 text-center">
        <p className="text-gray-500 dark:text-gray-400">Puan durumu bulunamadı</p>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-gray-50 dark:bg-gray-700 text-gray-600 dark:text-gray-300 text-sm">
              <th className="px-4 py-3 text-left font-semibold w-12">#</th>
              <th className="px-4 py-3 text-left font-semibold">Takım</th>
              <th className="px-4 py-3 text-center font-semibold w-12">O</th>
              <th className="px-4 py-3 text-center font-semibold w-12">G</th>
              <th className="px-4 py-3 text-center font-semibold w-12">B</th>
              <th className="px-4 py-3 text-center font-semibold w-12">M</th>
              <th className="px-4 py-3 text-center font-semibold w-16 hidden sm:table-cell">A</th>
              <th className="px-4 py-3 text-center font-semibold w-16 hidden sm:table-cell">Y</th>
              <th className="px-4 py-3 text-center font-semibold w-16 hidden md:table-cell">AV</th>
              <th className="px-4 py-3 text-center font-semibold w-14">P</th>
            </tr>
          </thead>
          <tbody>
            {standings.map((team, index) => (
              <tr
                key={team.url || index}
                className="border-t border-gray-100 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors"
              >
                <td className="px-4 py-3">
                  <span className={`inline-flex items-center justify-center w-7 h-7 rounded-full text-sm font-bold ${
                    team.rank === 1 ? 'bg-yellow-400 text-yellow-900' : 'bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-200'
                  }`}>
                    {team.rank}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <span className="font-medium text-gray-900 dark:text-white">
                    {team.teamName}
                  </span>
                </td>
                <td className="px-4 py-3 text-center text-gray-600 dark:text-gray-400">{team.played}</td>
                <td className="px-4 py-3 text-center text-green-600 dark:text-green-400 font-medium">{team.won}</td>
                <td className="px-4 py-3 text-center text-gray-600 dark:text-gray-400">{team.drawn}</td>
                <td className="px-4 py-3 text-center text-red-600 dark:text-red-400 font-medium">{team.lost}</td>
                <td className="px-4 py-3 text-center text-gray-600 dark:text-gray-400 hidden sm:table-cell">{team.goalsFor}</td>
                <td className="px-4 py-3 text-center text-gray-600 dark:text-gray-400 hidden sm:table-cell">{team.goalsAgainst}</td>
                <td className="px-4 py-3 text-center hidden md:table-cell">
                  <span className={`font-medium ${
                    team.goalDifference > 0 ? 'text-green-600 dark:text-green-400' :
                    team.goalDifference < 0 ? 'text-red-600 dark:text-red-400' :
                    'text-gray-600 dark:text-gray-400'
                  }`}>
                    {team.goalDifference > 0 ? `+${team.goalDifference}` : team.goalDifference}
                  </span>
                </td>
                <td className="px-4 py-3 text-center">
                  <span className="font-bold text-gray-900 dark:text-white text-lg">
                    {team.points}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      {/* Legend */}
      <div className="px-4 py-3 border-t border-gray-100 dark:border-gray-700 text-xs text-gray-500 dark:text-gray-400">
        <span>O: Oynanan, G: Galibiyet, B: Beraberlik, M: Mağlubiyet, A: Atılan, Y: Yenilen, AV: Averaj, P: Puan</span>
      </div>
    </div>
  );
};

export default StandingsTable;
